import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { stack } from "@ui/components/layout";
import { UserView } from "@ui/components/profile/userView";

interface GroupOwnerProps extends React.HTMLAttributes<HTMLDivElement> {
	group: Group;
}
export const GroupOwner: React.FC<GroupOwnerProps> = ({ group, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<div>{I18n.t(`group.${group.type}.owner.title`)}</div>
			<UserView user={group.owner} pictureSize="M" showDescription />
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 30px;
	${stack(16)};
	${({ theme }) => theme.textStyles.subtitle};
	.primaryName {
		${({ theme }) => theme.textStyles.subtitle};
	}
`;
